// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","primary":"#492172","tab":"_2a8p","active":"_2r8Y","pillTabs":"_1ont","pillTab":"_3A52"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Tabs/Tabs.scss
// module id = Lvnv
// module chunks = 0